import * as THREE from 'three';

// Room-only material treatment. Manufacturer door coatings stay in materials.js.
export function applyLuxuryMaterials(base, { load, own, software }) {
  const maps = name => ({
    map: load(`viewlux-colorado/${name}-color.webp`, true),
    normalMap: load(`viewlux-colorado/${name}-normal.png`),
    roughnessMap: load(`viewlux-colorado/${name}-roughness.webp`),
  });
  const quartz = maps('ivory'), trim = maps('trim');
  const feature = maps('feature'), wall = maps('wall');
  const oak = maps('oak-herringbone');
  Object.values(oak).forEach(texture => { texture.center.set(.5, .5); texture.rotation = Math.PI / 4; });
  const showroomFloor = own(new THREE.MeshPhysicalMaterial({
    ...oak, color: '#ffffff', metalness: 0, roughness: .82,
    normalScale: new THREE.Vector2(.35, .35), clearcoat: software ? 0 : .1,
    clearcoatRoughness: .7, envMapIntensity: .55,
  }), 'oak-herringbone-floor', 2.88);
  Object.assign(base.floor, quartz, {
    roughness: .58, clearcoat: software ? 0 : .28, clearcoatRoughness: .32,
    envMapIntensity: .75,
  });
  base.floor.color.set('#ffffff'); base.floor.normalScale.setScalar(.22);
  base.floor.userData.tileSize = 1.5;
  Object.assign(base.floorEdge, quartz, { roughness: .8 });
  base.floorEdge.color.set('#e0dccf'); base.floorEdge.userData.tileSize = 1.5;
  base.wall.color.set('#f7f2e8');
  base.darkMetal.color.set('#0f2420');
  const architecturalTrim = own(new THREE.MeshStandardMaterial({
    ...trim, color: '#ffffff', roughness: .82, metalness: 0,
    normalScale: new THREE.Vector2(.25, .25), envMapIntensity: .45,
  }), 'room-trim', 1.4);
  const featureWall = own(new THREE.MeshStandardMaterial({
    ...feature, color: '#b8c1bd', roughness: .94,
    normalScale: new THREE.Vector2(.3, .3),
  }), 'room-feature', 1.8);
  const galleryWall = own(new THREE.MeshStandardMaterial({
    ...wall, color: '#ffffff', roughness: .94,
    normalScale: new THREE.Vector2(.35, .35),
  }), 'room-wall', 2);
  const brass = own(new THREE.MeshStandardMaterial({
    color: '#c99658', metalness: .75, roughness: .35, envMapIntensity: .65,
  }), 'room-brass', .12);
  return { architecturalTrim, featureWall, galleryWall, brass, showroomFloor };
}